import { stat } from "fs";
import apiInstance from "services";

const CACHE_KEY = 'blessing-cache-';

export const getBlessing = async (params: BlessingParams): Promise<Blessing | undefined> => {
  try {
    const cached = getCachedBlessing(params.type);
    if (cached) {
      return cached;
    }
    
    const response = await apiInstance.post("/api/blessings/get", params);

    if(response.status === 200){
      localStorage.setItem(`${CACHE_KEY}${params.type}`, JSON.stringify(response.data));
    }

    return response.data;
  } 
  catch (error) {
    console.error(error);
    throw error;
  }
};

export const like = async (id: number, type: BlessingType, isLiked: boolean): Promise<boolean> => {
  try {
    const response = await apiInstance.post("/api/blessings/like", {
      BlessingId: id,
      IsLiked: isLiked
    });

    const cached = getCachedBlessing(type);
    if (cached) {
      localStorage.setItem(`${CACHE_KEY}${type}`, JSON.stringify({...cached, isLiked}));
    }

    return response.status === 200 ? isLiked : !isLiked;
  } 
  catch (error) {
    console.error(error);
    return !isLiked;
  }
};

export const secondsToMidnight = (): number => {
  const now = new Date();
  const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
  return Math.floor((midnight.getTime() - now.getTime()) / 1000);
};

export const whenIsBlessingExpiring = (type: BlessingType): number => {
  const cached = getCachedBlessing(type);
  
  if (!cached) return -1;

  const expiry = new Date(cached.expiresAtUtc);

  return expiry.getTime() - Date.now();
}

const getCachedBlessing = (type: BlessingType): Blessing | null => {
  const item = localStorage.getItem(`${CACHE_KEY}${type}`);
  if (!item) return null;
  
  const cached = JSON.parse(item) as Blessing;
  const expiry = new Date(cached.expiresAtUtc);

  return expiry.getTime() > Date.now() ? cached : null;
};


export interface Blessing {
  blessingID: number;
  params: BlessingParams;
  blessing: string;
  isLiked: boolean;
  createdAtUtc: string;
  expiresAtUtc: string;
}

export interface BlessingParams {
  elements: string[];
  numbers: number[];
  type: BlessingType;
  secToMidnight: number;
}

export type BlessingType = "love" | "work" | "health" | "relationships";
